import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Dumbbell, AlertCircle, MapPin } from 'lucide-react';
import AlumnoRegisterForm from '@/components/AlumnoRegisterForm';
import api from '@/lib/api';
export default function CustomerInviteRegister() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [gym, setGym] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchGym = async () => {
            try {
                const res = await api.get(`/public/gym-by-invite/${token}`);
                setGym(res.data.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Link de invitación inválido.');
            } finally {
                setLoading(false);
            }
        };
        fetchGym();
    }, [token]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white" />
            </div>
        );
    }

    if (error && !gym) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black px-4">
                <Card className="w-full max-w-md bg-[#0a0a0a] border-hairline-dark">
                    <CardHeader className="text-center">
                        <div className="flex justify-center mb-4">
                            <div className="h-12 w-12 bg-white/10 rounded-xl flex items-center justify-center">
                                <AlertCircle className="h-6 w-6 text-white" />
                            </div>
                        </div>
                        <CardTitle className="text-2xl font-bold text-white">Link inválido</CardTitle>
                        <CardDescription className="text-white/60">{error}</CardDescription>
                    </CardHeader>
                    <CardContent className="text-center">
                        <Button onClick={() => navigate('/')} className="w-full">Volver al inicio</Button>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-black py-8 px-4 relative">
            <div className="max-w-lg mx-auto space-y-6">
                {/* Gym header */}
                <div className="text-center space-y-3">
                    {gym?.logo ? (
                        <img src={gym.logo} alt={gym.name} className="h-16 w-16 object-contain mx-auto rounded-lg border border-hairline-dark bg-white/10" />
                    ) : (
                        <div className="h-16 w-16 bg-white/10 rounded-xl flex items-center justify-center mx-auto">
                            <Dumbbell className="h-8 w-8 text-white" />
                        </div>
                    )}
                    <div>
                        <h1 className="text-2xl font-bold uppercase tracking-wide text-white">{gym?.name}</h1>
                        {gym?.address && (
                            <p className="text-sm text-white/60 flex items-center justify-center gap-1 mt-1">
                                <MapPin className="h-3 w-3" />
                                {gym.address}
                            </p>
                        )}
                    </div>
                </div>

                <AlumnoRegisterForm token={token} gymName={gym?.name} />

                <div className="text-center">
                    <Button variant="outline" size="sm" onClick={() => navigate('/')}
                    className="text-white border-white/30 hover:bg-white/10">
                        ← Volver al inicio
                    </Button>
                </div>
            </div>
        </div>
    );
}
